import axios from "../axios";

class ContractorTypeService {
    getListIdNameAll() {
        return axios.get("contractor-type?perPage=1000&fields[contractor_type]=id,slug,name");
    }
}

export default new ContractorTypeService();
